module.exports = __webpack_public_path__ + "img/hokkaido_soup.6168b098.jpg";